import React, {ReactNode} from 'react'
import styled from 'styled-components'
import {Colors} from '../../../../../styledComponents/Constants'
import {DoubleArrow, Notes} from '@mui/icons-material'
import {LeftRowFlexContainer} from '../../../../../styledComponents/FlexComponents'

import { Tabs, Tab, Box } from '@mui/material';

interface Props {
    detailInfo: React.ReactNode;
    statusInfo: React.ReactNode;
    onChange?: () => void;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export const NatAdminSpApplicationTabComponent: React.FC<Props> = props => {
    const TabPanel = (tablePanelProps: TabPanelProps) => (
        <div
            role="tabpanel"
            hidden={tablePanelProps.value !== tablePanelProps.index}
            id={`application-tabpanel-${tablePanelProps.index}`}
            aria-labelledby={`application-tab-${tablePanelProps.index}`}
        >
            {tablePanelProps.value === tablePanelProps.index &&
                tablePanelProps.children
            }
        </div>
    )

    const renderTab = (index: number, labelComponent: ReactNode) => (
        <StyledTab
            id={`application-tab-${index}`}
            aria-controls={`application-tabpanel-${index}`}
            label={labelComponent}
        />
    )

    const [value, setValue] = React.useState(0)

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue)
    }

    const detailTabLabel = <LeftRowFlexContainer>
        <Notes/><Box ml={'4px'}/>申請内容
    </LeftRowFlexContainer>

    const statusTabLabel = <LeftRowFlexContainer>
        <DoubleArrow/><Box ml={'4px'}/>進行状況
    </LeftRowFlexContainer>


    return (
        <TabsArea>
            <Tabs
                value={value}
                onChange={handleChange}
                variant={'fullWidth'}
                indicatorColor={'primary'}
                textColor={'primary'}
            >
                {renderTab(0, detailTabLabel)}
                {renderTab(1, statusTabLabel)}
            </Tabs>
            <Box mt={'-2px'} borderBottom={`2px solid ${Colors.AccentLight}`}/>
            <TabPanel value={value} index={0}>
                {props.detailInfo}
            </TabPanel>
            <TabPanel value={value} index={1}>
                {props.statusInfo}
            </TabPanel>
        </TabsArea>
    )
}

const TabsArea = styled.div`
  background-color: ${Colors.Surface};
`

const StyledTab = styled(Tab)`
  &.MuiTab-root {
    height: 56px;
    font-weight: bold;
  }
`
